import gsap from 'gsap';
import type { KaraokeRevealTypes } from './karaoke-reveal.types';
import { karaokeRevealOptions } from './karaoke-reveal.config';
import { splitElement } from '../split/split';

export function karaokeReveal(
  element: HTMLElement,
  options?: Partial<KaraokeRevealTypes>,
): gsap.core.Timeline {
  const { duration, ease, rightAlpha, leftAlpha, direction } = {
    ...karaokeRevealOptions,
    ...options,
  };
  const timeline = gsap.timeline();

  const lines = splitElement(
    element as HTMLElement,
    'lines',
    {
      linesClass: '',
    },
    false,
  );

  lines.forEach((line) =>
    timeline.fromTo(
      line,
      {
        maskImage: `linear-gradient(to ${direction}, rgba(0, 0, 0, ${leftAlpha}) 0%, rgba(0, 0, 0, ${rightAlpha}) 0%)`,
        width: 'fit-content',
      },
      {
        duration,
        ease,
        maskImage: `linear-gradient(to ${direction}, rgba(0, 0, 0, ${leftAlpha}) 100%, rgba(0, 0, 0, ${rightAlpha}) 100%)`,
      },
    ),
  );

  return timeline;
}
